<template>
  <div>
    <div class="col-lg-12 col-xxl-12">
      <div class="element-actions">
        <form class="form-inline justify-content-sm-end">
          <label class="smaller" for=""></label>
          <select class="form-control form-control-sm form-control-faded" v-model="period">
            <option v-for="option in periods" v-bind:value="option.value">
              {{ t.filter.accounting[option.value] }}
            </option>
          </select>
        </form>
      </div>
      <div class="element-balances">
        <div class="balance hidden-mobile">
          <div class="balance-title">{{t.total_payments}}</div>
          <div class="balance-value"><span>{{ result.income | toMoney(currency) }}</span>
          </div>
          <div class="balance-link"><router-link :to="{name: 'orders', query: {type: [30,31]}}" class="btn btn-link btn-underlined"><span>{{ t.navigation.deposit_transactions }}</span><i class="os-icon os-icon-arrow-right4"></i></router-link></div>
        </div>
        <div class="balance">
          <div class="balance-title">{{t.total_withdrawal}}</div>
          <div class="balance-value">{{ result.outcome | toMoney(currency) }}</div>
          <div class="balance-link"><router-link :to="{name: 'orders', query: {type: [5,9,10,16,32]}}" class="btn btn-link btn-underlined btn-gold"><span>{{ t.navigation.withdraw_transactions }}</span><i class="os-icon os-icon-arrow-right4"></i></router-link></div>
        </div>
        <div class="balance">
          <div class="balance-title">{{t.remaining}}</div>
          <div class="balance-value danger">{{ result.remaining | toMoney(currency) }}</div>
          <div class="balance-link"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: 'incomeOverview',
        data () {
            return {
                result: null,
                currency: null,
                t: this.$root.t,
                provider: '*',
                providers: [
                    {label: 'All', value: '*'},
                    {label: 'Slots', value: 'SLOTS'},
                    {label: 'Live Tombola', value: 'LIVE_TOMBOLA'},
                    {label: 'Evolution', value: 'EVOLUTION'},
                    {label: 'VIVO Gaming', value: 'Vivo_Gaming'},
                    {label: 'Ezugi', value: 'EZUGI'}
                ],
                period: 'today',
                periods: [
                    { label: 'Today', value: 'today' },
                    { label: 'Yesterday', value: 'yesterday' },
                    { label: 'This Week', value: 'this_week' },
                    { label: 'This Month', value: 'this_month' },
                    { label: 'Q1', value: 'q1' },
                    { label: 'Q2', value: 'q2' },
                    { label: 'Q3', value: 'q3' },
                    { label: 'Q4', value: 'q4' },
                    { label: 'Financial First Half', value: 'first_financial_half' },
                    { label: 'Financial Second Half', value: 'second_financial_half' },
                ]
            }
        },
        watch: {
            period () {
                this.fetchOverview();
            },
            provider () {
                this.fetchOverview();
            }
        },
        mounted () {
            this.fetchOverview();
        },
        methods: {
            fetchOverview () {
                this.$http.get(api+'api/v1/analytics/income/overview', {params: {period: this.period, provider: this.provider} } ).then(response => {

                    this.result = response.body.result.slice(-1).pop();
                    this.currency = response.body.currency;
                }, response => {

                })
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/accounting/widget/overview.vue